import { render } from "./UserInfoViewCard.vue?vue&type=template&id=6173fdbf"
import script from "./UserInfoViewCard.vue?vue&type=script&lang=js"
export * from "./UserInfoViewCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__